/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateStripeSessionMutationVariables = {|
  priceId: string,
  currency: string,
  unit_amount: number,
  interval: string,
  trial?: ?boolean,
|};
export type CreateStripeSessionMutationResponse = {|
  +createStripeSession: ?{|
    +stripeSession: ?{|
      +session_id: ?string
    |}
  |}
|};
export type CreateStripeSessionMutation = {|
  variables: CreateStripeSessionMutationVariables,
  response: CreateStripeSessionMutationResponse,
|};
*/


/*
mutation CreateStripeSessionMutation(
  $priceId: String!
  $currency: String!
  $unit_amount: Int!
  $interval: String!
  $trial: Boolean
) {
  createStripeSession(priceId: $priceId, currency: $currency, unitAmount: $unit_amount, interval: $interval, trial: $trial) {
    stripeSession {
      session_id
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currency"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "interval"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priceId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trial"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "unit_amount"
},
v5 = [
  {
    "kind": "Variable",
    "name": "currency",
    "variableName": "currency"
  },
  {
    "kind": "Variable",
    "name": "interval",
    "variableName": "interval"
  },
  {
    "kind": "Variable",
    "name": "priceId",
    "variableName": "priceId"
  },
  {
    "kind": "Variable",
    "name": "trial",
    "variableName": "trial"
  },
  {
    "kind": "Variable",
    "name": "unitAmount",
    "variableName": "unit_amount"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "session_id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateStripeSessionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "CreateStripeSession",
        "kind": "LinkedField",
        "name": "createStripeSession",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeSessionNode",
            "kind": "LinkedField",
            "name": "stripeSession",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateStripeSessionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "CreateStripeSession",
        "kind": "LinkedField",
        "name": "createStripeSession",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeSessionNode",
            "kind": "LinkedField",
            "name": "stripeSession",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "60cd4ee2f2c749fb0c4b121fc4b29cba",
    "id": null,
    "metadata": {},
    "name": "CreateStripeSessionMutation",
    "operationKind": "mutation",
    "text": "mutation CreateStripeSessionMutation(\n  $priceId: String!\n  $currency: String!\n  $unit_amount: Int!\n  $interval: String!\n  $trial: Boolean\n) {\n  createStripeSession(priceId: $priceId, currency: $currency, unitAmount: $unit_amount, interval: $interval, trial: $trial) {\n    stripeSession {\n      session_id\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '382b23111c29992e05d3abc6e85a43f6';

module.exports = node;
